import { render, staticRenderFns } from "./WidgetHelp.vue?vue&type=template&id=c4db639c&scoped=true"
import script from "./WidgetHelp.vue?vue&type=script&lang=js"
export * from "./WidgetHelp.vue?vue&type=script&lang=js"
import style0 from "./WidgetHelp.vue?vue&type=style&index=0&id=c4db639c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4db639c",
  null
  
)

export default component.exports